var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderbuttonhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3996_53185)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.123,
    cy: 16,
    r: 15,
    stroke: "#FEFEFE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8668 20.1254L24.132 16L19.8668 11.8746C19.5418 11.5601 19.5418 11.0468 19.8668 10.7324C20.1872 10.4225 20.7033 10.4225 21.0237 10.7324L25.8793 15.4289C26.2043 15.7433 26.2043 16.2567 25.8793 16.5711L21.0237 21.2676C20.7033 21.5775 20.1872 21.5775 19.8668 21.2676C19.5418 20.9532 19.5418 20.4399 19.8668 20.1254Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3793 11.8746L8.11413 16L12.3793 20.1254C12.7043 20.4399 12.7043 20.9532 12.3792 21.2676C12.0589 21.5775 11.5428 21.5775 11.2224 21.2676L6.36684 16.5711C6.04178 16.2567 6.04178 15.7433 6.36684 15.4289L11.2224 10.7324C11.5428 10.4225 12.0589 10.4225 12.3792 10.7324C12.7043 11.0468 12.7043 11.5601 12.3793 11.8746Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3996_53185"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.123047,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderbuttonhover);
export default __webpack_public_path__ + "static/media/sliderbuttonhover.3d471ba4.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderbuttonhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3996_53185)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.123,
    cy: 16,
    r: 15,
    stroke: "#FEFEFE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8668 20.1254L24.132 16L19.8668 11.8746C19.5418 11.5601 19.5418 11.0468 19.8668 10.7324C20.1872 10.4225 20.7033 10.4225 21.0237 10.7324L25.8793 15.4289C26.2043 15.7433 26.2043 16.2567 25.8793 16.5711L21.0237 21.2676C20.7033 21.5775 20.1872 21.5775 19.8668 21.2676C19.5418 20.9532 19.5418 20.4399 19.8668 20.1254Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3793 11.8746L8.11413 16L12.3793 20.1254C12.7043 20.4399 12.7043 20.9532 12.3792 21.2676C12.0589 21.5775 11.5428 21.5775 11.2224 21.2676L6.36684 16.5711C6.04178 16.2567 6.04178 15.7433 6.36684 15.4289L11.2224 10.7324C11.5428 10.4225 12.0589 10.4225 12.3792 10.7324C12.7043 11.0468 12.7043 11.5601 12.3793 11.8746Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3996_53185"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.123047,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderbuttonhover);
export default __webpack_public_path__ + "static/media/sliderbuttonhover.3d471ba4.svg";
export { ForwardRef as ReactComponent };